// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"Rating_ratingContainer__2vOg8"};